import React from "react";
import logo from "../assets/img/beachcomber.png";
import { basename } from "../config";

export default class PageNotFound extends React.Component {


    render() {
        return (
            <div className="page-not-found-wrapper">
                <div className=" text-center ">
              <div className="">
                <a href={"/"}>
                  <img alt="beachcomber logo" src={logo} className="logo" />
                </a>
              </div>

              <div className="">
               
                <h3 className="app-title text-muted ">
                  BEACHCOMBER<span className="bcb-primary-color">B2B</span>
                </h3>
                
              </div>

             
            </div>
                <div className="d-flex justify-content-center align-items-center ">
                    <div className="page-not-found">
                        <h1>404</h1>
                    <h5>Sorry, there's nothing to see here <a href="/">Go back</a>.</h5>
                    </div>
               
                </div>
                
            </div>
        )
    }
}